<div class="proficiency-edit-card">
  <div class="proficiency-edit-header" [formGroup]="form">
    <span class="proficiency-edit-heading">{{
      'tlc.positions.import_skills_flow.summary_dialog.review_skills.proficiency_details.heading'
        | translate
    }}</span>
    <div class="header-actions">
      <rt-button variant="primary" size="small" (click)="onSave()">{{
        'tlc.positions.import_skills_flow.summary_dialog.review_skills.skill_details.save'
          | translate
      }}</rt-button>
      <rt-button size="small" (click)="cancel.emit()">{{
        'tlc.positions.import_skills_flow.summary_dialog.review_skills.skill_details.cancel'
          | translate
      }}</rt-button>
    </div>
  </div>

  <div class="proficiency-edit-fields" [formGroup]="form">
    <rt-form-field>
      <rt-label>{{
        'tlc.positions.import_skills_flow.summary_dialog.review_skills.proficiency_details.proficiency_level'
          | translate
      }}</rt-label>
      <rt-input formControlName="name" />
    </rt-form-field>
    <rt-form-field>
      <rt-label>{{
        'tlc.positions.import_skills_flow.summary_dialog.review_skills.proficiency_details.assigned_positions'
          | translate
      }}</rt-label>
      <rt-select2
        #positionSelect
        formControlName="positions"
        [items]="positionItems()"
        withMultiselect
        withSearch
      >
        <rt-select-trigger-multi />
        <ng-template [rtSelectSelectedItem]="positionSelect" let-remove="remove" let-item="item">
          <rt-chips [text]="item.label" [showClose]="true" (close)="remove(item)" />
        </ng-template>
        <ng-template rtSelectSelectedItemCounter let-hiddenCount="hiddenCount">
          <rt-chips [text]="'+' + hiddenCount" [showClose]="false" />
        </ng-template>
        <ng-template
          [rtSelectListItem]="positionSelect"
          let-selectCtrl
          let-item="item"
          let-isHoverState="isHoverState"
        >
          <rt-dropdown-item (click)="selectCtrl.select$.next(item)" [class.hover]="isHoverState">
            <rt-checkbox
              prefix
              [checked]="selectCtrl.itemSelector.isSelected(item)"
              [hasMargin]="false"
              (valueChange)="selectCtrl.select$.next(item)"
            />
            <span>{{ item.label }}</span>
          </rt-dropdown-item>
        </ng-template>
      </rt-select2>
    </rt-form-field>
    <rt-form-field>
      <rt-label>{{
        'tlc.positions.import_skills_flow.summary_dialog.review_skills.proficiency_details.description'
          | translate
      }}</rt-label>
      <rt-textarea formControlName="description" [rows]="5" />
    </rt-form-field>
  </div>
  <rt-button class="delete-button" variant="plain" size="small" (click)="delete.emit()">
    <rt-icon name="delete" prefix />
    <span>{{
      'tlc.positions.import_skills_flow.summary_dialog.review_skills.proficiency_details.delete_level'
        | translate
    }}</span>
  </rt-button>
</div>
